import React from "react";
import { Grid } from "@material-ui/core";

import { getApiUrl } from "../../config/api";
import CoinPanel from "./components/coinPanel";
import useRatePolling from "./hooks/useRatePolling";
import { Styles } from '../style/tabContentStyle'

const CURRENCY_RATE_URL = getApiUrl("currency-rate");
const CURRENCY_ERROR_MESSAGE = "دریافت نرخ ارزها با خطا مواجه شد.";
const CURRENCY_COUNTRIES = {
  AED: { flag: "🇦🇪", name: "امارات متحده عربی" },
  AZN: { flag: "🇦🇿", name: "جمهوری آذربایجان" },
  EUR: { flag: "🇪🇺", name: "اتحادیه اروپا" },
  GBP: { flag: "🇬🇧", name: "بریتانیا" },
  TRY: { flag: "🇹🇷", name: "ترکیه" },
  USD: { flag: "🇺🇸", name: "آمریکا" },
};
const CURRENCY_PRIORITY = ["USD", "TRY"];

const formatPrice = (price) => {
  const numericPrice = Number(price);

  return Number.isFinite(numericPrice)
    ? numericPrice.toLocaleString("fa-IR", { maximumFractionDigits: 2 })
    : price;
};

const formatUnit = (unit) => unit === "TOMAN" ? "تومان" : unit;

const sortCurrencies = (currencies) => [...currencies].sort((firstCurrency, secondCurrency) => {
  const firstPriority = CURRENCY_PRIORITY.indexOf(firstCurrency.code);
  const secondPriority = CURRENCY_PRIORITY.indexOf(secondCurrency.code);

  if (firstPriority === -1 && secondPriority === -1) {
    return 0;
  }

  if (firstPriority === -1) {
    return 1;
  }

  if (secondPriority === -1) {
    return -1;
  }

  return firstPriority - secondPriority;
});

const Currencies = () => {
  const { data: currencies, isLoading, error } = useRatePolling(
    CURRENCY_RATE_URL,
    CURRENCY_ERROR_MESSAGE
  );

  return (
    <Styles>
      <Grid className="currencies" container>
        <Grid item md={12} xs={12}>
          {isLoading ? (
            <div className="tab-message">در حال دریافت نرخ ارزها...</div>
          ) : currencies.length === 0 && error ? (
            <div className="tab-message error">{error}</div>
          ) : currencies.length === 0 ? (
            <div className="tab-message">نرخ ارزی برای نمایش وجود ندارد.</div>
          ) : (
            <>
              {error && <div className="refresh-error">{error}</div>}
              <Grid container alignItems="stretch" spacing={2}>
                {sortCurrencies(currencies).map((currency) => (
                  <Grid item md={6} sm={12} xs={12} key={currency.code}>
                    <CoinPanel
                      icon={CURRENCY_COUNTRIES[currency.code]?.flag}
                      iconLabel={`پرچم ${CURRENCY_COUNTRIES[currency.code]?.name || currency.title}`}
                      title={`${currency.title} (${currency.code})`}
                      displayPrice={formatPrice(currency.price)}
                      unit={formatUnit(currency.unit)}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Styles>
  );
};

export default Currencies;
